/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import L from "../Lang"
import BaseCom from "../BaseCom";

export default class Roundup extends BaseCom {

    componentDidMount() {
        this.fillItem('/api/dashboard/roundup?dt=' + Globals.toISODateString(new Date()), 'item');
    }

    render() {
        return <div>
            <table className="table table-striped">
            <thead>
                <tr>
                    <th><L>Patient Conversion Status</L></th>
                    <th><L>Daily</L></th>
                    <th><L>Weekly</L></th>
                    <th><L>MTD</L></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><L>Insurance Approvals</L></td>
                    <td>{this.state.item?.insuranceApprovals?.daily}</td>
                    <td>{this.state.item?.insuranceApprovals?.weekly}</td>
                    <td>{this.state.item?.insuranceApprovals?.mtd}</td>
                </tr>
                <tr>
                    <td><L>Clinical Approvals *</L></td>
                    <td>{this.state.item?.clinicalApprovals?.daily}</td>
                    <td>{this.state.item?.clinicalApprovals?.weekly}</td>
                    <td>{this.state.item?.clinicalApprovals?.mtd}</td>
                </tr>
                <tr>
                    <td><L>Converted Patients</L></td>
                    <td>{this.state.item?.convertedPatients?.daily}</td>
                    <td>{this.state.item?.convertedPatients?.weekly}</td>
                    <td>{this.state.item?.convertedPatients?.mtd}</td>
                </tr>
                <tr>
                    <td><L>Added to Calendar</L></td>
                    <td>{this.state.item?.addedToCalendar?.daily}</td>
                    <td>{this.state.item?.addedToCalendar?.weekly}</td>
                    <td>{this.state.item?.addedToCalendar?.mtd}</td>
                </tr>
            </tbody>
        </table>
        <p className="note"><i><L>* Clinical Approvals date was not previously tracked. Tracking begins on 8/19/2024.</L></i></p>
        </div>;
    }
}